module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.woff?338f6f873b90c8045204f8ac52408166";